import React, { createContext } from 'react'
import { node } from 'prop-types'

const inistialState = {
  isUpdateWorker: false,
  isSuccessWorker: false,
  registrationWorker: null
}

export const ServiceWorkerContext = createContext(inistialState)

const ProvideWorker = ({ children, ...rest }) => {
  return (
    <ServiceWorkerContext.Provider {...rest}>
      {children}
    </ServiceWorkerContext.Provider>
  )
}
ProvideWorker.propTypes = { children: node }
ProvideWorker.defaultProps = { children: undefined }

export default ProvideWorker
